import { useState } from 'react'
import { OneMessage } from '@yy/one-ui'
import Api from '@/services/http'
import type * as Types from './type'

interface IS3Config {
  uploadSceneId: string
  fileName?: string
}

const parseUploadInfo = (infoArray: Record<string, any>[]) => {
  if (!infoArray) {
    return {}
  }

  const data = {}
  infoArray.forEach((info) => {
    data[info.key] = info.value
  })

  return data
}

/** 生成预授权上传URL */
export const getAmazonS3Api = async (params: IS3Config) => {
  if (!params) {
    return OneMessage.info('required params config, must be Object')
  }

  const response = await Api.admin.post<Types.S3ResponseType>('/api/media/s3/get_upload_pre_Url', params)
  const { bizCode, data } = response
  if (bizCode === 'SUCCESS') {
    const { actionUrl, fields, headers, fileId } = data
    const uploadFormData = new FormData()

    // 组装formdata 数据
    fields.forEach((item: any) => {
      uploadFormData.append(item.key, item.value)
    })

    return {
      actionUrl,
      data: uploadFormData,
      headers: { ...parseUploadInfo(headers || []), 'content-type': 'multipart/form-data' },
      fileId,
      fields,
    }
  }

  return Promise.reject(response)
}

/** 上传到亚马逊 */
export const uploadAmazon = async (params: { url: string; formData: any; headers: any; onUploadProgress?: (e: ProgressEvent) => void }) => {
  const response = await Api.post(params.url, params.formData, {
    headers: { ...params.headers },
    onUploadProgress: params?.onUploadProgress,
    timeout: 60e3,
    withCredentials: false,
  })
  const { status } = response
  if (status === 204) {
    return {
      bizCode: 'SUCCESS',
      data: response,
    }
  }

  return response
  // return Promise.reject({
  //   bizCode: 'UPLOAD_FAIL',
  //   bizMessage: 'batchOrder.uploadError',
  //   message: 'batchOrder.uploadError',
  // })
}

interface IUseUploadS3 {
  /** 获取预签名URL失败 */
  getS3PreUrlErrCallback?: (e) => void

  /** 上传成功 */
  uploadSuccessCallback?: (resp) => void

  /** 上传失败 */
  uploadErrCallback?: (e) => void
}
interface IDoUpload {
  scene: string
  file: any
  /** 上传进度事件 */
  onUploadProgress?: (e: ProgressEvent) => void
  fileName?: string
}
export function useUploadS3(option: IUseUploadS3 = {}) {
  const { getS3PreUrlErrCallback, uploadSuccessCallback, uploadErrCallback } = option

  const [uploadData, setUploadData] = useState<any>({})
  const doUpload = async (config: IDoUpload) => {
    if (!config) {
      OneMessage.info('required params config')
      return
    }

    let s3Resp
    try {
      s3Resp = await getAmazonS3Api({
        uploadSceneId: config.scene,
      })

      setUploadData(s3Resp)
    } catch (e) {
      getS3PreUrlErrCallback && getS3PreUrlErrCallback(e)
    }

    if (s3Resp) {
      const { actionUrl, data: formData, headers, fileId } = s3Resp
      if (actionUrl && fileId) {
        formData.append('file', config.file)
        // (2) 获取上传文件到亚马逊服务器
        try {
          const respUploadS3Resp = await uploadAmazon({ url: actionUrl, formData, headers, onUploadProgress: config?.onUploadProgress })
          uploadSuccessCallback && uploadSuccessCallback(respUploadS3Resp)
        } catch (e) {
          uploadErrCallback && uploadErrCallback(e)
        }
      }
    }
  }

  return {
    doUpload,
    uploadData,
  }
}

interface IUseUploadImage {
  successCallback?: FnType
  errorCallback?: FnType
  returnKey?: 'key' | 'fileUri'
}

export function useUploadImage(option = {} as IUseUploadImage) {
  const { successCallback, errorCallback, returnKey = 'key' } = option

  const doUpload = async (config: IDoUpload) => {
    if (!config) {
      OneMessage.info('required params config')
      return
    }
    const { scene, fileName } = config
    try {
      const {
        actionUrl,
        data: formData,
        headers,
        fields,
        fileId,
      } = (await getAmazonS3Api({
        uploadSceneId: scene,
        fileName,
      })) as any

      const object = fields.reduce((acc, next) => {
        acc[next.key] = next.value
        return acc
      }, {})

      if (actionUrl && fileId) {
        formData.append('file', config.file)
        await uploadAmazon({ url: actionUrl, formData, headers })
        const returnValue = object[returnKey]

        successCallback?.(returnValue)
        return returnValue
      }
      return ''
    } catch (e) {
      errorCallback?.(e)
      return ''
    }
  }

  return {
    doUpload,
  }
}
